import { render } from "./AIDetail.vue?vue&type=template&id=ab0f9eee"
import script from "./AIDetail.vue?vue&type=script&lang=js"
export * from "./AIDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__